import { render } from "./GetInTouch.vue?vue&type=template&id=45a5b854&scoped=true"
import script from "./GetInTouch.vue?vue&type=script&lang=js"
export * from "./GetInTouch.vue?vue&type=script&lang=js"

import "./GetInTouch.vue?vue&type=style&index=0&id=45a5b854&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a5b854"]])

export default __exports__